import COMMON_CONSTANTS from "../constants/commonConstants";

/**
 * @desc It'll call the NodeJS End-point /logging-portal to log the Portal request.
 * @param body request Object {message, portalType}
 * @returns {{result : 'Logged'} | Error}
 */
export default function logPortalRequest(body) {
  return fetch(COMMON_CONSTANTS.LOGGING_PORTAL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((res) => {
      return res.json();
    })
    .catch(() => {
      return { error: true };
    });
}

